export default function ComparisonSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50 relative">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 relative z-10">
        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-background-100 border border-background-200 mb-6">
          <span className="text-foreground-600 text-sm font-semibold">Confronto</span>
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
          Itaobuy Spreadsheet vs Ricerca Tradizionale
        </h2>
        <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-[720px] mb-14">
          Ecco un confronto diretto tra l&apos;utilizzo di <strong>Itaobuy Spreadsheet</strong> e i metodi di ricerca tradizionali.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-2xl overflow-hidden border border-background-200">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-5 font-semibold text-foreground-700 text-sm">Metodo</th>
                <th className="text-left px-6 py-5 font-semibold text-foreground-700 text-sm">Tempo</th>
                <th className="text-left px-6 py-5 font-semibold text-foreground-700 text-sm">Organizzazione</th>
                <th className="text-left px-6 py-5 font-semibold text-foreground-700 text-sm">Facilit&agrave;</th>
                <th className="text-left px-6 py-5 font-semibold text-foreground-700 text-sm">Affidabilit&agrave;</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200">
                <td className="px-6 py-5">
                  <strong className="text-foreground-950">Itaobuy Spreadsheet</strong>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-sm font-semibold">
                    <i className="ri-check-line text-xs"></i>Basso
                  </span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-sm font-semibold">
                    <i className="ri-check-line text-xs"></i>Alta
                  </span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-sm font-semibold">
                    <i className="ri-check-line text-xs"></i>Facile
                  </span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-sm font-semibold">
                    <i className="ri-check-line text-xs"></i>Alta
                  </span>
                </td>
              </tr>
              <tr className="border-b border-background-200">
                <td className="px-6 py-5 text-foreground-800">Ricerca manuale</td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Alto</span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Bassa</span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Media</span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Media</span>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-5 text-foreground-800">Marketplace tradizionale</td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Medio</span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Media</span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Facile</span>
                </td>
                <td className="px-6 py-5">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-sm">Bassa</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Very%20faint%20minimalist%20grid%20and%20product%20silhouette%20pattern%20texture%20on%20cream%20background%2C%20extremely%20subtle%20checklist%20style%20watermark%2C%20clean%20organizational%20theme%2C%20warm%20sand%20and%20beige%20tones%2C%20barely%20visible%20repeating%20elements&width=1200&height=800&seq=itaobuy-comparison-v2-bg&orientation=landscape')`,
        }}
      ></div>
    </section>
  );
}